import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { MaintenanceForwardingsDirectiveFromSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'

export const directiveEntriesAdditionalDirectiveSteps: Partial<{
  [K in MaintenanceForwardingsDirectiveEntryKlass]: {
    beforeRequiredDirectiveSteps: MaintenanceForwardingsDirectiveFromSteps[]
    afterRequiredDirectiveSteps: MaintenanceForwardingsDirectiveFromSteps[]
  }
}> = {
  [MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry]: {
    beforeRequiredDirectiveSteps: [MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity],
    afterRequiredDirectiveSteps: [],
  },
  [MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry]: {
    beforeRequiredDirectiveSteps: [MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic],
    afterRequiredDirectiveSteps: [],
  },
}
